import React, { useEffect, useState } from 'react';
import { Container, Grid } from '@material-ui/core'
import { DialogSystemGLPure, SimpleLoading, BoxSomeHeadersGLPure, ButtonHLPure, SubtitlePageHLPure, PromotionalFooterPure } from '../../pures';
import FollowUpDocumentEntities from './follow-up-document-entities';
import FollowUpDocumentPDF from './follow-up-document-pdf';
import FollowUpDocumentBasicData from './follow-up-document-basic-data';
import FollowUpDocumentVarsPersonalized from './follow-up-document-vars';
import './digital-vault-follow-up-document.view.css';
import { changeFormatNumberToShow, convertStringInDates, convertDateBDToShow, changeFormatNumberToSend } from '../../../utils';
import FollowUpDocumentFiles from './follow-up-document-files';
import { DigitalVaultUploadAction } from '../../actions';

const DigitalVaultFollowUpDocumentView = (props) => {

    let {
        t,
        monetaryUnits,
        toggleCompletedRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        isLoading,
        showLoadingRequesting,
        showErrorRequesting,
        showCompletedRequesting,
        messageError,
        documentData,
        entities,
        handleSaveData,
        titleView,
        handleCancel,
        showEntities,
        showDocumentPDF,
        showBasicData,
        showVariables,
        nameBtnNext,
        showBtnNextStatus,
        handleFillInData,
        showBtnDataInCapture,
        optionsUse,
        variablesToShow,
        backBtnName,
        handleBack,
        showBtnBackStatus,
        showDocumentGrid,
        setSelectedFile,
        selectedFile,
        status,
        workflowExecutionId,
        noWorkflow,
        handleSubmitNoWorkflow,
        urlSelected,
        handleSelectFile,
        toggleError,
        entitiesOptions
    } = props


    const [entity, setEntity] = useState('')
    const [resumeEntiti, setResumenEntiti] = useState('')
    const [useSelected, seUseSelected] = useState(0)
    const [entitySelected, setEntitySelected] = useState({})
    const [name, setName] = useState('')
    const [alias, setAlias] = useState('')
    const [description, setDescription] = useState('')
    const [valueDocument, setValueDocument] = useState(0.00)
    const [confidential, setConfidential] = useState(false)
    const [obligatory, setObligatory] = useState(false)
    const [penalty, setPenalty] = useState(false)
    const [tags, setTags] = useState([])
    const [dateStart, setDateStart] = useState('')
    const [errorInputDateStart, setErrorInputDateStart] = useState(false)
    const [errorInputTextDateStart, setErrorInputTextDateStart] = useState('')
    const [dateEnd, setDateEnd] = useState('')
    const [errorInputDateEnd, setErrorInputDateEnd] = useState(false)
    const [errorInputTextDateEnd, setErrorInputTextDateEnd] = useState('')
    const [entitiesGrid, setEntitiesGrid] = useState([])
    const [errorInputValueDoc, setErrorInputValueDoc] = useState(false)
    const [errorInputTextValueDoc, setErrorInputTextValueDoc] = useState('')
    const [formatCeleb, setFormatCeleb] = useState('dd/MM/yyyy')
    const [formatVen, setFormatVen] = useState('dd/MM/yyyy')
    const [variables, setVariables] = useState([])
    const [optionsToUse, setOptionsToUse] = useState(optionsUse)
    const [inputTag, setInputTag] = useState('')
    const [limitDateDue, setLimitDateDue] = useState('')
    const [entityName, setEntityName] = useState('')
    const [monetaryUnit, setMonetaryUnit] = useState('')
    const [notify, setNotify] = useState(false)

    useEffect(() => {
        if (!documentData) return
        let aliasBD = (documentData.alias) ? documentData.alias : ''
        let descriptionBD = (documentData.description) ? documentData.description : ''
        let startDateBD = (documentData.startDate) ? convertDateBDToShow(documentData.startDate) : ''
        let firstDate = (documentData.startDate) ? convertDateBDToShow(documentData.startDate) : ''
        let endDateBD = (documentData.validation) ? convertDateBDToShow(documentData.validation) : ''
        let amountBD = (documentData.amount) ? changeFormatNumberToShow(documentData.amount, 1) : 0.00
        amountBD = (amountBD && amountBD !== 'isNaN') ? amountBD : 0.00
        let confidentialBD = (documentData.confidential === 'true') ? true : false
        let obligatoryBD = (documentData.mandatory === 'true') ? true : false
        let penaltyBD = (documentData.penaltyFee === true) ? true : false
        let tagsBD = (documentData.tags) ? documentData.tags : []
        let limitDateDue = (firstDate) ? new Date(firstDate.setDate(firstDate.getDate() + 1)) : ''
        let monetaryUnit = documentData.monetaryUnit ? documentData.monetaryUnit : ""
        let notifyBD = (documentData.notify === 'true') ? true : false

        setTags(tagsBD)
        setPenalty(penaltyBD)
        setObligatory(obligatoryBD)
        setConfidential(confidentialBD)
        setValueDocument(amountBD)
        setDateEnd(endDateBD)
        setDateStart(startDateBD)
        setDescription(descriptionBD)
        setAlias(aliasBD)
        setName(documentData.name)
        setEntitiesGrid(entities)
        setVariables(variablesToShow)
        setLimitDateDue(limitDateDue)
        setMonetaryUnit(monetaryUnit)
        setNotify(notifyBD)
    }, [documentData])

    const handleChangeName = (e) => {
        let value = e.target.value
        setName(value)
    }

    const handleChangeAlias = (e) => {
        let value = e.target.value
        setAlias(value)
    }

    const handleChangeDescription = (e) => {
        let value = e.target.value
        setDescription(value)
    }

    const onChangeDatepicker = (e) => {
        setDateStart(e.target.value)

        let value = e.target.value
        let limitDateDue = (value) ? new Date(value.setDate(value.getDate() + 1)) : ''
        setLimitDateDue(limitDateDue)
        if (!dateEnd) {
            let dateEndYear = (value) ? new Date(value.setDate(value.getDate() + 365)) : ''
            setDateEnd(dateEndYear)
        }
    }

    const onChangeDatepickerDateEnd = (e) => {
        setDateEnd(e.target.value)
    }

    const handleChangeValueDoc = (e) => {
        let value = e.target.value
        value = value.replace(/([^0-9.]+)/, "");
        value = value.replace(/^(0|\.)/, "");
        setValueDocument(value)
    }

    const handleChangeCheckConfidential = (e) => {
        let value = e.target.checked
        setConfidential(value)
    }

    const handleChangeCheckObligatory = (e) => {
        let value = e.target.checked
        setObligatory(value)
    }

    const handleChangeCheckPenalty = (e) => {
        let value = e.target.checked
        setPenalty(value)
    }

    const handleMonetaryUnit = (e) => setMonetaryUnit(e.target.value)

    const handleEntiti = (e) => {
        let value = e.target.value
        setEntity(value)
        setErrorInputDateStart(false)
        setErrorInputTextDateStart('')
        setErrorInputDateEnd(false)
        setErrorInputTextDateEnd('')
        setErrorInputTextValueDoc('')
        setErrorInputValueDoc(false)
    }

    const handleResumeEntiti = (e) => {
        let value = e.target.value
        setResumenEntiti(value)
    }

    const filterChangeUse = (e) => {
        if (!entity) return
        let value = e.target.value
        value = (value) ? Number(value) : 0
        seUseSelected(value);
        setEntitiesToValue(value)
    };


    /**
     * @author Pedro Antonio
     * @typedef {object} Props
     * @property {number} status
     * @param {Props} props
     * @return {JSX.Element} 
     */
    const RenderMedia = ({ status }) => {
        return (
            <>
                {(status === +process.env.REACT_APP_NEW_DOCUMENT_STATUS_300120) && (
                    <>
                        {!showBasicData && props.fileType === "video" &&
                            <Grid item xs={12} md={6}>
                                <div className='followUpDocumentEntities-documentPDF' >
                                    <div className='followUpDocumentEntities-documentPDF-container'>
                                        <video
                                            disablePictureInPicture
                                            disableRemotePlayback
                                            controls
                                            src={props.urlSelected}
                                            width={"100%"}
                                            height={"100%"} />
                                    </div>
                                </div>
                            </Grid>
                        }
                        {!showBasicData && props.fileType === "image" &&
                            <Grid item xs={12} md={6}>
                                <div className='followUpDocumentEntities-documentPDF' >
                                    <div className='followUpDocumentEntities-documentPDF-container'>
                                        <img
                                            src={props.urlSelected}
                                            width={"100%"}
                                            height={"100%"}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        }
                    </>
                )}
                {(status === +process.env.REACT_APP_NEW_DOCUMENT_STATUS_300130) && (
                    <>
                        {props.fileType === "video" &&
                            <Grid item xs={12} md={6}>
                                <div className='followUpDocumentEntities-documentPDF' >
                                    <div className='followUpDocumentEntities-documentPDF-container'>
                                        <video
                                            disablePictureInPicture
                                            disableRemotePlayback
                                            controls
                                            src={props.urlSelected}
                                            width={"100%"}
                                            height={"100%"} />
                                    </div>
                                </div>
                            </Grid>
                        }
                        {props.fileType === "image" &&
                            <Grid item xs={12} md={6}>
                                <div className='followUpDocumentEntities-documentPDF' >
                                    <div className='followUpDocumentEntities-documentPDF-container'>
                                        <img
                                            src={props.urlSelected}
                                            width={"100%"}
                                            height={"100%"}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        }
                    </>
                )}
                {(status === +process.env.REACT_APP_STATUS_DOCUMENT_NO_VALIDATED_ID) && (
                    <>
                        {props.fileType === "video" &&
                            <Grid item xs={12} md={6}>
                                <div className='followUpDocumentEntities-documentPDF' >
                                    <div className='followUpDocumentEntities-documentPDF-container'>
                                        <video
                                            disablePictureInPicture
                                            disableRemotePlayback
                                            controls
                                            src={props.urlSelected}
                                            width={"100%"}
                                            height={"100%"} />
                                    </div>
                                </div>
                            </Grid>
                        }
                        {props.fileType === "image" &&
                            <Grid item xs={12} md={6}>
                                <div className='followUpDocumentEntities-documentPDF' >
                                    <div className='followUpDocumentEntities-documentPDF-container'>
                                        <img
                                            src={props.urlSelected}
                                            width={"100%"}
                                            height={"100%"}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        }
                    </>
                )}
            </>
        )
    }

    //Save information and send next status
    const handleSave = () => {
        let errorMessage = ''
        if (props.canEditName && (!name || name.trim().length == 0)) {
            errorMessage = t("digitalVaultFollowUpDocumentView.errors.add.name")
        }

        if (!alias || !description || !dateStart) {
            if (!alias) {
                errorMessage = t("digitalVaultFollowUpDocumentView.errors.add.alias")
            }

            if (!description) {
                errorMessage = t("digitalVaultFollowUpDocumentView.errors.add.description")
            }

            if (!dateStart) {
                errorMessage = t("digitalVaultFollowUpDocumentView.errors.add.start.date")
            }
        }

        if (errorMessage !== '') {
            toggleErrorRequesting(errorMessage, 4000, false)
            return
        }

        toggleLoadingRequesting(true)
        let entitiesSend = { values: entitiesGrid }

        let startDate = dateStart
        let validation = dateEnd
        let valueConvert = valueDocument.toString().replaceAll(',', '')
        let amount = (valueConvert && !isNaN(valueConvert)) ? changeFormatNumberToSend(valueConvert, 1) : 0.00
        let mandatory = obligatory
        let tagsSend = []
        tags.map((tag) => {
            tagsSend.push(tag.text)
        })
        let nameDocument = (props.canEditName) ? name : null
        let workflowEXP = (Number(documentData.workflowId) !== Number(process.env.REACT_APP_ID_NEW_DOCUMENT)) ? true : null
        const clientId = JSON.parse(localStorage.getItem("user")).userMetaData.userMifirma.clientId

        let monetaryFound = monetaryUnits.find(item => item.pluralName === monetaryUnit && (item.creatorClientId === clientId || !item.creatorClientId))
        monetaryFound = monetaryFound && monetaryFound.id ? monetaryFound.id : null
        let notify = (documentData.notify === 'true') ? true : false

        handleSaveData(alias, description, startDate, validation, amount, confidential, notify, mandatory, penalty, tagsSend, entitiesSend, variables, nameDocument, null, null, null, workflowEXP, monetaryFound)
    }

    //Setea a la entidad seleccionada en el grid
    const handleEntitySelected = (entity) => {
        setEntitySelected(entity)
        setEntity(entity.name)
        setEntityName(entity.name)
        seUseSelected(0)
        setErrorInputDateStart(false)
        setErrorInputTextDateStart('')
        setErrorInputDateEnd(false)
        setErrorInputTextDateEnd('')
        setErrorInputTextValueDoc('')
        setErrorInputValueDoc(false)
    }

    const setEntitiesToValue = (entityValue) => {
        if (!entity) return
        changeUseFromEntity(entityValue)

    }

    const changeUseFromEntity = (valueEntity) => {
        let copyEntities = [...entitiesGrid]
        let use = ''
        let asigned = 0
        let entities = copyEntities.map((copyEntity) => {
            switch (valueEntity) {
                case 0:
                    use = ''
                    asigned = 0
                    break;
                case 1:
                    setAlias(entity)
                    use = t("digitalVaultFollowUpDocumentView.use.alias")
                    asigned = 1
                    break;
                case 2:
                    setDescription(entity)
                    use = t("digitalVaultFollowUpDocumentView.use.description")
                    asigned = 2
                    break;
                case 3:
                    let dateStart = convertStringInDates(entity)
                    if (!dateStart) {
                        setErrorInputDateStart(true)
                        setErrorInputTextDateStart(t("digitalVaultFollowUpDocumentView.errors.invalid.date"))
                        return copyEntity
                    }
                    setDateStart(dateStart.date)
                    setFormatCeleb(dateStart.format)
                    use = t("digitalVaultFollowUpDocumentView.use.celebration")
                    asigned = 3
                    break;
                case 4:
                    let dateEnd = convertStringInDates(entity)
                    if (!dateEnd) {
                        setErrorInputDateEnd(true)
                        setErrorInputTextDateEnd(t("digitalVaultFollowUpDocumentView.errors.invalid.date"))
                        return copyEntity
                    }
                    setDateEnd(dateEnd.date)
                    setFormatVen(dateEnd.format)
                    use = t("digitalVaultFollowUpDocumentView.use.expiration")
                    asigned = 4
                    break;
                case 5:
                    let valueConvert = entity.replaceAll(',', '')
                    let numberConvert = changeFormatNumberToShow(valueConvert, 1)
                    if (!numberConvert || numberConvert === 'NaN') {
                        setErrorInputTextValueDoc(t("digitalVaultFollowUpDocumentView.errors.invalid.number"))
                        setErrorInputValueDoc(true)
                        return copyEntity
                    }
                    use = t("digitalVaultFollowUpDocumentView.use.value")
                    asigned = 5
                    setValueDocument(numberConvert)
                    break;
                case 6:
                    setConfidential(true)
                    use = t("digitalVaultFollowUpDocumentView.use.confidenciality")
                    asigned = 6
                    break;
                case 7:
                    setObligatory(true)
                    use = t("digitalVaultFollowUpDocumentView.use.mandatory")
                    asigned = 7
                    break;
                case 8:
                    setPenalty(true)
                    use = t("digitalVaultFollowUpDocumentView.use.penalty")
                    asigned = 8
                    break;
                case 9:
                    use = t("digitalVaultFollowUpDocumentView.use.tags")
                    asigned = 9
                    handleCreateTag()
                    break;
                case 10:
                    use = t("digitalVaultFollowUpDocumentView.use.vars")
                    asigned = 10
                    break;
                default:
                    use = t("digitalVaultFollowUpDocumentView.use.vars")
                    asigned = valueEntity
                    break;
            }

            if (copyEntity.name === entitySelected.name) {
                copyEntity.use = use
                copyEntity.asigned = asigned
            }
            return copyEntity
        })
        if (copyEntities.length === 0) {
            switch (valueEntity) {
                case 1:
                    setAlias(entity)
                    break;
                case 2:
                    setDescription(entity)
                    break;
                case 3:
                    let dateStart = convertStringInDates(entity)
                    if (!dateStart) {
                        setErrorInputDateStart(true)
                        setErrorInputTextDateStart(t("digitalVaultFollowUpDocumentView.errors.invalid.date"))
                        return
                    }
                    setDateStart(dateStart.date)
                    setFormatCeleb(dateStart.format)
                    break;
                case 4:
                    let dateEnd = convertStringInDates(entity)
                    if (!dateEnd) {
                        setErrorInputDateEnd(true)
                        setErrorInputTextDateEnd(t("digitalVaultFollowUpDocumentView.errors.invalid.date"))
                        return
                    }
                    setDateEnd(dateEnd.date)
                    setFormatVen(dateEnd.format)
                    break;
                case 5:
                    let valueConvert = entity.replaceAll(',', '')
                    let numberConvert = changeFormatNumberToShow(valueConvert, 1)
                    if (!numberConvert || numberConvert === 'NaN') {
                        setErrorInputTextValueDoc(t("digitalVaultFollowUpDocumentView.errors.invalid.number"))
                        setErrorInputValueDoc(true)
                        return
                    }
                    setValueDocument(numberConvert)
                    break;
                case 6:
                    setConfidential(true)
                    break;
                case 7:
                    setObligatory(true)
                    break;
                case 8:
                    setPenalty(true)
                    use = 'penal'
                    asigned = 8
                    break;
                case 9:
                    handleCreateTag()
                    break;
                case 10:
                    asigned = 10
                    break;
                default:
                    break;
            }
        }
        setEntitiesGrid(entities)
    }

    useEffect(() => {
        setEntitiesGrid(entities)
    }, [entitiesOptions])

    const handleCreateTag = () => {
        let newTag = {
            text: (entity) ? entity : null,
            value: tags.length + 1,
            action: 1
        }

        let copyTags = [...tags]
        if (newTag && newTag.text) {
            copyTags.push(newTag)
            setTags(copyTags)
        }
    }

    const handleDeleteChipTag = (e) => {
        let copyTags = [...tags]
        let tagDelete = e.target.props.dataItem
        let tagsFilter = copyTags.filter((tag) => tag.value !== tagDelete.value)
        setTags(tagsFilter)
    }

    const onBlurValueDoc = () => {
        let numberConvert = changeFormatNumberToShow(valueDocument, 1)
        if (!numberConvert || numberConvert === 'NaN') {
            setErrorInputTextValueDoc(t("digitalVaultFollowUpDocumentView.errors.invalid.number"))
            setErrorInputValueDoc(true)
            return
        }
        setValueDocument(numberConvert)

    }

    const handleInputTag = (e) => {
        let value = e.target.value
        setInputTag(value)
    }

    const onBlurInputTag = () => {
        let copyTags = [...tags]
        let newTag = {
            text: (inputTag) ? inputTag : null,
            value: copyTags.length + 1,
            action: 1
        }

        if (newTag && newTag.text) {
            copyTags.push(newTag)
            setTags(copyTags)
            setInputTag('')
        }
    }

    const handleBackStatus = () => {
        handleBack()
    }

    const handleChangeDropEntities = (e) => {
        let newEntities = []
        let value = e.target.value
        value = value || t("parseEntities.all.entities")

        if (value === t("parseEntities.all.entities")) {
            newEntities = entities
        } else {
            value = (value === t("parseEntities.others.entities")) ? t("parseEntities.others") : value
            newEntities = entities.filter(entity => entity.type === value)
        }

        setEntitiesGrid(newEntities)
    }

    if (isLoading) return <div className='standard-wrapper'>
        <SimpleLoading />
    </div>

    return (
        <>
            {
                status === Number(process.env.REACT_APP_NEW_DOCUMENT_STATUS_300105) ? (
                    <DigitalVaultUploadAction
                        documentId={documentData.id}
                        workflowExecutionId={workflowExecutionId}
                        handleSaveData={handleSaveData}
                        documentData={documentData}
                        noWorkflow={noWorkflow}
                        handleSubmitNoWorkflow={handleSubmitNoWorkflow}
                        t={t}
                    />
                ) : (
                    <div className='digitalVaultFollowUpDocument-wrapper'>
                        <Container>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <SubtitlePageHLPure subtitle={titleView} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <BoxSomeHeadersGLPure
                                                flexColumn1={true}
                                                titleOne={documentData.infoType == 'Documento' ? t("digitalVaultFollowUpDocument.name.document") : t("digitalVaultFollowUpDocument.name.file")}
                                                subtitleOne={documentData.name}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container spacing={3}>
                                                {
                                                    showEntities && (
                                                        <Grid item xs={12} md={6}>
                                                            <FollowUpDocumentEntities
                                                                entity={entity}
                                                                entitiesOptions={entitiesOptions}
                                                                resumeEntiti={resumeEntiti}
                                                                handleEntiti={handleEntiti}
                                                                handleResumeEntiti={handleResumeEntiti}
                                                                filterChangeUse={filterChangeUse}
                                                                useSelected={useSelected}
                                                                seUseSelected={seUseSelected}
                                                                setEntitySelected={setEntitySelected}
                                                                entitiesGrid={entitiesGrid}
                                                                handleEntitySelected={handleEntitySelected}
                                                                variables={variables}
                                                                optionsToUse={optionsToUse}
                                                                setOptionsToUse={setOptionsToUse}
                                                                handleChangeDropEntities={handleChangeDropEntities}
                                                                {...props}
                                                            />
                                                        </Grid>
                                                    )
                                                }
                                                {
                                                    (showBasicData || showVariables) &&
                                                    <Grid item xs={12} md={6}>
                                                        <Grid container spacing={3}>
                                                            {
                                                                titleView === t("digitalVaultFollowUpDocumentAction.title.edit") &&
                                                                <Grid item xs={12}>
                                                                    <FollowUpDocumentFiles
                                                                        t={t}
                                                                        documentData={documentData}
                                                                        selectedFile={selectedFile}
                                                                        setSelectedFile={setSelectedFile}
                                                                    />
                                                                </Grid>
                                                            }
                                                            {
                                                                showBasicData && (
                                                                    <Grid item xs={12}>
                                                                        <FollowUpDocumentBasicData
                                                                            t={t}
                                                                            name={name}
                                                                            alias={alias}
                                                                            obligatory={obligatory}
                                                                            confidential={confidential}
                                                                            valueDocument={valueDocument}
                                                                            description={description}
                                                                            tags={tags}
                                                                            handleChangeName={handleChangeName}
                                                                            handleChangeAlias={handleChangeAlias}
                                                                            handleChangeDescription={handleChangeDescription}
                                                                            onChangeDatepicker={onChangeDatepicker}
                                                                            handleChangeValueDoc={handleChangeValueDoc}
                                                                            handleChangeCheckConfidential={handleChangeCheckConfidential}
                                                                            handleChangeCheckObligatory={handleChangeCheckObligatory}
                                                                            handleDeleteChipTag={handleDeleteChipTag}
                                                                            dateStart={dateStart}
                                                                            dateEnd={dateEnd}
                                                                            errorInputTextDateStart={errorInputTextDateStart}
                                                                            errorInputDateStart={errorInputDateStart}
                                                                            errorInputTextDateEnd={errorInputTextDateEnd}
                                                                            errorInputDateEnd={errorInputDateEnd}
                                                                            onChangeDatepickerDateEnd={onChangeDatepickerDateEnd}
                                                                            handleChangeCheckPenalty={handleChangeCheckPenalty}
                                                                            penalty={penalty}
                                                                            errorInputValueDoc={errorInputValueDoc}
                                                                            errorInputTextValueDoc={errorInputTextValueDoc}
                                                                            onBlurValueDoc={onBlurValueDoc}
                                                                            formatCeleb={formatCeleb}
                                                                            formatVen={formatVen}
                                                                            inputTag={inputTag}
                                                                            handleInputTag={handleInputTag}
                                                                            onBlurInputTag={onBlurInputTag}
                                                                            limitDateDue={limitDateDue}
                                                                            monetaryUnit={monetaryUnit}
                                                                            handleMonetaryUnit={handleMonetaryUnit}
                                                                            {...props}
                                                                        />
                                                                    </Grid>
                                                                )
                                                            }
                                                            {
                                                                showVariables && (
                                                                    <Grid item xs={12}>
                                                                        <FollowUpDocumentVarsPersonalized
                                                                            t={t}
                                                                            entitiesGrid={entitiesGrid}
                                                                            setEntitiesGrid={setEntitiesGrid}
                                                                            useSelected={useSelected}
                                                                            entity={entity}
                                                                            variables={variables}
                                                                            setVariables={setVariables}
                                                                            optionsToUse={optionsToUse}
                                                                            {...props}
                                                                        />
                                                                    </Grid>
                                                                )
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                }
                                                {(props.fileType === "pdf" &&
                                                    showDocumentPDF) &&
                                                    <Grid item xs={12} md={6}>
                                                        <FollowUpDocumentPDF
                                                            {...props}
                                                            urlSelected={urlSelected || ''}
                                                        />
                                                    </Grid>
                                                }
                                                <RenderMedia status={status} />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} className='digitalVaultFollowUpDocument-container-btns'>
                                            <ButtonHLPure
                                                nameBtn={t("button.cancel")}
                                                onClickBtn={handleCancel}
                                            />
                                            {
                                                showBtnDataInCapture && (
                                                    <ButtonHLPure
                                                        nameBtn={t("digitalVaultFollowUpDocument.btn.fill.in")}
                                                        primary
                                                        onClickBtn={handleFillInData}
                                                    />
                                                )
                                            }
                                            {
                                                showBtnBackStatus && (
                                                    <ButtonHLPure
                                                        nameBtn={backBtnName}
                                                        primary={false}
                                                        onClickBtn={() => handleBackStatus()}
                                                    />
                                                )
                                            }
                                            {
                                                showBtnNextStatus && (
                                                    <ButtonHLPure
                                                        nameBtn={nameBtnNext}
                                                        primary
                                                        onClickBtn={(noWorkflow) ? () => handleSubmitNoWorkflow() : () => handleSave()}
                                                    />
                                                )
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <PromotionalFooterPure />
                                </Grid>
                            </Grid>
                        </Container>
                    </div>
                )
            }
            <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                showCompletedRequesting={showCompletedRequesting}
                showErrorRequesting={showErrorRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                toggleErrorRequesting={toggleError}
                message={messageError}
            />
        </>
    )
}

export { DigitalVaultFollowUpDocumentView as default }